import React, {useEffect} from 'react';
import s from '../../PersonalOffice/CreateInvoice/CreateInvoicePopup/CreateInvoicePopup.module.css';
import CommonSvgSelector from '../../assets/common/SVG/CommonSvgSelector';
import DepotProductsList from '../DepotComponents/DepotProductsList';
import {useTranslation} from 'react-i18next';
import {FormikValues, useFormikContext} from 'formik';
import {ProductInDepotType} from '../../types/ProductSliceTypes';
import {formatWeight} from '../../assets/utils/utils';

type Props = {
	close: () => void;
	prepareProducts: ProductInDepotType[];
	changeProductCallback: (id: string, action: '+' | '-' | 'manual' | 'remove') => void;
};

const ProductsListForCreationPopup: React.FC<Props> = ({
	prepareProducts,
	changeProductCallback,
	close,
}) => {
	const {t} = useTranslation();
	const {values, setFieldValue} = useFormikContext<FormikValues>();

	// Рассчитываем суммы на основе выбранных товаров
	const {sumPoints, sumMoney, sumSale, sumCashback, sumWeight} =
		prepareProducts.reduce(
			(
				acc: {
					sumPoints: number;
					sumMoney: number;
					sumSale: number;
					sumCashback: number;
					sumWeight: number;
				},
				curr,
			) => {
				const qty = Number(curr.buyQuantity || 0);
				const points = Number(curr.points || 0);
				const money = Number(curr.money || 0);
				const sale = Number(curr.sale || 0);
				const cashback = Number(curr.cashback || 0);
				const weight = Number(curr.weight || 0); // вес одной позиции

				return {
					sumPoints: acc.sumPoints + points * qty,
					sumMoney: acc.sumMoney + money * qty,
					sumSale: acc.sumSale + sale * qty,
					sumCashback: acc.sumCashback + cashback * qty,
					sumWeight: acc.sumWeight + weight * qty,
				};
			},
			{sumPoints: 0, sumMoney: 0, sumSale: 0, sumCashback: 0, sumWeight: 0},
		);

	// Если есть данные в форме (при редактировании), используем их как fallback
	const finalPoints = sumPoints > 0 ? sumPoints : Number(values.points || 0);
	const finalMoney = sumMoney > 0 ? sumMoney : Number(values.money || 0);
	const finalWeight = sumWeight > 0 ? sumWeight : Number(values.weight || 0);
	const finalCashback = sumCashback > 0 ? sumCashback : Number(values.cashback || 0);
	const finalSale = sumSale > 0 ? sumSale : Number(values.discount || 0);

	useEffect(() => {
		setFieldValue('points', finalPoints);
		setFieldValue('money', finalMoney);
		setFieldValue('cashback', finalCashback);
		setFieldValue('discount', finalSale);
		setFieldValue('weight', finalWeight);
	}, [finalMoney, finalPoints, finalCashback, finalSale, finalWeight, setFieldValue]);

	return (
		<>
			<div className={s.closeCross}>
				<span onClick={close} role={'button'} tabIndex={0}>
					<CommonSvgSelector id={'closeCross'} />
				</span>
			</div>
			<div className={s.title}>
				<h4>{t('Ваш обраний товар')}</h4>
			</div>
			<div className={s.popupTable}>
				<DepotProductsList
					key={prepareProducts.length} // Принудительное перерендеривание при изменении количества товаров
					products={prepareProducts}
					isLoading={false}
					changeProductCallback={changeProductCallback}
					hideStockColumn={true}
				/>
			</div>
			<div className={s.total}>
				<div className={s.totalNames}>
					<div>{t('Загальна вага')}:</div>
					<div>{t('Всього балів')}:</div>
					<div>{t('Всього грошей')}:</div>
				</div>
				<div className={s.totalValues}>
					<div>{formatWeight(finalWeight)} кг</div>
					<div>{finalPoints} Б</div>
					<div>{finalMoney} грн</div>
				</div>
			</div>
		</>
	);
};
export default ProductsListForCreationPopup;
